import React, { useCallback, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import jwt_decode from "jwt-decode";
// react-bootstrap components
import { useDispatch } from "react-redux";
import { Collapse, Nav } from "react-bootstrap";
import { verification } from "../../Redux/usersReduce";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-multi-lang'
import {
  FcSettings,
  FcBusinessman,
  FcButtingIn,
  FcNumericalSorting12,
  FcNews,
  FcPaid,
  FcInTransit,
  FcShipped,
  FcDocument,
  FcCheckmark,
  FcFinePrint,
  FcLeave,
  FcPlus,
  FcInspection,
  FcSurvey, FcComments
} from "react-icons/fc";
import { RxAvatar } from "react-icons/rx";
import { CgProfile } from "react-icons/cg";
import Configuration from "../../configuration";

function Sidebar({ routes, background, users, client }) {


  const t = useTranslation();
  const dispatch = useDispatch();
  const { entities } = useSelector(state => state.settings);
  let location = useLocation();

  const nom = users.user.nom_prenom;
  const [state, setState] = React.useState({});
  let lang = window.localStorage.getItem("lang");
  const icon = {
    FcSettings: <FcSettings />,
    FcBusinessman: <FcBusinessman />,
    FcNews: <FcNews />,
    FcButtingIn: <FcButtingIn />,
    FcNumericalSorting12: <FcNumericalSorting12 />,
    FcInTransit: <FcInTransit />,
    FcPaid: <FcPaid />,
    FcShipped: <FcShipped />,
    FcFinePrint: <FcFinePrint />,
    FcCheckmark: <FcCheckmark />,
    FcDocument: <FcDocument />,
    FcLeave: <FcLeave />,
    FcPlus: <FcPlus />,
    FcInspection: <FcInspection />,
    FcSurvey: <FcSurvey />,
    FcComments: <FcComments />,
    CgProfile: <CgProfile />
  }
  /* const { entities } = useSelector((state) => state.settings); */
  // const { rootBase } = useSelector((state) => state.rootBase);
  // var routes = rootBase ? rootBase[0] : [];
  var token = localStorage.getItem("x-access-token");
  var decoded = jwt_decode(token);
  var id_role = users.user.id_role;
  const [image, setImage] = React.useState(null);

  React.useEffect(() => {
    /* setState(getCollapseStates(routes)); */
  }, []);
  const getCollapseInitialState = (routes) => {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (location.pathname === routes[i].layout + routes[i].path) {
        return true;
      }
    }
    return false;
  };

  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        } else {
          setImage(e.payload.image)
        }
      })
    } catch (error) {

    }

  }, [dispatch]);

  // this function creates the links and collapses that appear in the sidebar (left menu)
  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      var st = {};
      var name = prop.name;
      if (lang === "fr") name = prop.name;
      else if (lang === "en" && prop.name_en !== null) name = prop.name_en;
      getTitle(prop.path, name);
      // var iconComp = icon[prop.icon]

      if ((prop.role.includes(id_role)) || prop.role.includes(20)) {
        if (prop.redirect) {
          return null;
        }
        if (prop.collapse) {
          st[prop["state"]] = !state[prop.state];
          return (
            <Nav.Item
              className={getCollapseInitialState(prop.views) ? "active" : ""}
              as="li"
              key={key}
            >
              <Nav.Link
                className={state[prop.state] ? "collapsed" : ""}
                data-toggle="collapse"
                onClick={(e) => {
                  e.preventDefault();
                  setState({ ...state, ...st });
                }}
                aria-expanded={state[prop.state]}
              >
                {/* <i>    {iconComp}</i> */}
                <i className={prop.icon}></i>
                <p>

                  {name} <b className="caret"></b>
                </p>
              </Nav.Link>
              <Collapse in={state[prop.state]}>
                <div>
                  <Nav as="ul">{createLinks(prop.views)}</Nav>
                </div>
              </Collapse>
            </Nav.Item>
          );
        }
        return (
          <Nav.Item className={activeRoute(prop.path)} key={key} as="li">
            {/* {getTitle(prop.path, prop.name)} */}
            <Nav.Link className={prop.className} to={prop.path} as={Link}>
              {prop.icon ? (
                <>
                  {/* <i>{iconComp}</i> */}
                  <i className={prop.icon}></i>
                  <p>
                    {name}
                  </p>
                </>
              ) : (
                <>
                  <span className="sidebar-mini">{prop.mini}</span>
                  <span className="sidebar-normal">{name}</span>
                </>
              )}
            </Nav.Link>
          </Nav.Item>
        );
      } else {
        return null;
      }
    });
  };
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname === routeName ? "active" : "";
  };
  function getTitle(routeName, name) {
    if (location.pathname.toUpperCase() === routeName.toUpperCase())
      document.title = name;
  }

  React.useEffect(() => {
    verifToken()
  }, []);

  const getImageSrc = (client) => {
 
    if (client === undefined) {
      return require("../../assets/img/logo.png");
    }
   
    if (client === "medis") {
      return require("../../assets/img/logomedis.png");
    }
    if (client === "neapolis") {
      return require("../../assets/img/logoneapolis.png");
    } 
    console.log("hello",client)
    return require("../../assets/img/logo.png"); // fallback
  
};

  return (
    <>
      <div className={"sidebar "+client} data-color={background}>
      
        <div className="sidebar-wrapper">
          <div className="logotop">
            <div className="bglogo">
              <img
                className="icon-profil"
                src={getImageSrc(client)}
                alt="icon-profil"
              />
             
            </div>
          </div>
         
          <Nav as="ul">{createLinks(routes)}</Nav>

          <div className="logo">

          </div>
        </div>
      </div>
    </>
  );
}

Sidebar.defaultProps = {
  image: "",
  background: "black",
  routes: [],
};

export default Sidebar;
